import React from 'react'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import TitledContent from 'components/TitledContent/TitledContent'
import Icon from 'components/Icon/Icon'
import CountUp from 'components/CountUp/CountUp'
import NoData from 'components/NoData/NoData'
import messages from './messages'
import styles from './DashboardInsights.scss'

const SECTIONS = ['nonFiler', 'underReport'] as const

interface DashboardInsightsProps {
  counts?: {
    nonFiler?: number
    underReport?: number
    nonRegister?: number
  }
}

const DashboardInsights = ({ counts = {} }: DashboardInsightsProps) => (
  <div className={styles.container}>
    {SECTIONS.map(key => (
      <div key={key} className={cx(styles.section, styles[key])}>
        <Icon name={key} direction='left' size='regular' className={styles.icon} />
        <TitledContent
          key={key}
          title={<FormattedMessage {...(messages.titles as any)[key]} />}
          titleClassName={styles.title}
          contentClassName={styles.count}
        >
          {counts[key] ? <CountUp to={counts[key]!} /> : <NoData />}
        </TitledContent>
      </div>
    ))}
  </div>
)

export default DashboardInsights

